import { FC } from 'react';
import { createPortal } from 'react-dom';
import cn from 'bem-cn';

import { Icon } from '../Icon';
import { ModalProps } from './Modal.types';
import { useSwipeToClose, useEscapeClose, useBodyScrollLock } from './Modal.hooks';

import './Modal.scss';

const b = cn('modal');

export const Modal: FC<ModalProps> = ({ isOpen, onClose, children, showDefaultCloseButton = true }) => {
    // Хук для обработки свайпа на тач устройствах
    const { contentRef, getSwipeStyles, getSwipeClassName, getModalClassName, getDynamicAnimationStyle } =
        useSwipeToClose({
            isOpen,
            onClose,
            threshold: 100,
            velocityThreshold: 0.3,
        });

    // Закрытие по Escape и блокировка скролла
    useEscapeClose(isOpen, onClose);
    useBodyScrollLock(isOpen);

    // Закрытие по клику на фон
    const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) {
        return null;
    }

    return createPortal(
        <div className={`${b()} ${getModalClassName()}`} onClick={handleBackdropClick}>
            <div
                ref={contentRef}
                className={`${b('content')} ${getSwipeClassName()}`}
                style={{ ...getSwipeStyles(), ...getDynamicAnimationStyle() }}
            >
                {showDefaultCloseButton && (
                    <button className={b('close-button')} onClick={onClose} type="button" aria-label="Закрыть">
                        <Icon name="close" size={24} />
                    </button>
                )}
                {children}
            </div>
        </div>,
        document.body,
    );
};
